import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Молодежный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Конкретный вид туристской деятельности юношества и подростков, реализуемый как в рамках
                        национальных границ, так и на региональном и мировых уровнях.</p>
                </div>
            </div>
        </>
    );
}